import React from "react"
import "./WhoWeArePage.css"

const WhoWeArePage = () => {
  return (
    <div className="epw-who-page">

      <main>
        <header className="epw-hero">
          <div className="epw-wrap">
            <p className="epw-eyebrow">Who We Are</p>
            <h1>Independent intelligence with an international perspective.</h1>
            <p>
              EnergyPulseWorld is powered by EnergyPulse Inc., an Estonia-based company
              bringing together specialist research, statistical analysis and regional
              market insight to support better-informed business decisions.
            </p>
          </div>
        </header>

        <section className="epw-main">
          <div className="epw-wrap">

            <section className="epw-intro">
              <div>
                <p className="epw-eyebrow">Our Organization</p>
                <h2>The team behind EnergyPulseWorld.</h2>
              </div>

              <div className="epw-intro-copy">
                <p>
                  EnergyPulse Inc. provides the organizational and analytical foundation
                  behind EnergyPulseWorld, combining international reach with focused
                  expertise in energy, economics, industry and trade.
                </p>
                <p>
                  Our work is designed around rigorous research, careful compilation of
                  authoritative information and practical interpretation of the developments
                  shaping global and regional markets.
                </p>
              </div>
            </section>

            <section className="epw-company-band">
              <div>
                <p className="epw-eyebrow" style={{ color: "#ffb2bf" }}>Powered by</p>
                <h2>EnergyPulse Inc.</h2>
              </div>

              <div>
                <p>
                  Headquartered in Estonia and supported by branches in Singapore, Lebanon
                  and Botswana, EnergyPulse Inc. combines a European corporate base with
                  direct proximity to key markets across Asia, the Middle East and Africa.
                </p>
              </div>
            </section>

            <section>
              <div className="epw-section-head">
                <p className="epw-eyebrow">International Footprint</p>
                <h2>Four locations. One connected research network.</h2>
                <p>
                  Our structure supports regional awareness while maintaining a consistent
                  methodology and analytical approach across EnergyPulseWorld.
                </p>
              </div>

              <div className="epw-office-grid">
                <article className="epw-office-card">
                  <span>Headquarters</span>
                  <h3>Estonia</h3>
                  <p>
                    Corporate base and coordination hub for EnergyPulse Inc. and the
                    EnergyPulseWorld platform.
                  </p>
                </article>

                <article className="epw-office-card">
                  <span>Branch</span>
                  <h3>Singapore</h3>
                  <p>
                    Supporting insight into Asian energy markets, trade flows and regional
                    industrial developments.
                  </p>
                </article>

                <article className="epw-office-card">
                  <span>Branch</span>
                  <h3>Lebanon</h3>
                  <p>
                    Supporting regional research and analysis across the Middle East and
                    surrounding markets.
                  </p>
                </article>

                <article className="epw-office-card">
                  <span>Branch</span>
                  <h3>Botswana</h3>
                  <p>
                    Supporting market intelligence and research across Sub-Saharan Africa.
                  </p>
                </article>
              </div>
            </section>

            <section>
              <div className="epw-section-head">
                <p className="epw-eyebrow">Our People</p>
                <h2>Research-led. Data-driven. Regionally informed.</h2>
                <p>
                  EnergyPulseWorld is supported by high-calibre teams combining analytical,
                  statistical and market expertise.
                </p>
              </div>

              <div className="epw-team-grid">
                <article className="epw-team-card">
                  <h3>Research Analysts</h3>
                  <p>
                    Specialists who monitor energy, economic, industrial and trade developments,
                    identify material changes and translate them into decision-relevant insight.
                  </p>
                </article>

                <article className="epw-team-card">
                  <h3>Statisticians &amp; Data Specialists</h3>
                  <p>
                    Professionals who compile, compare, validate and structure country and market
                    indicators to support consistent cross-country and time-series analysis.
                  </p>
                </article>

                <article className="epw-team-card">
                  <h3>Regional Expertise</h3>
                  <p>
                    Market knowledge across Asia, the Middle East and Africa helps ensure that
                    global developments are interpreted within the realities of individual regions.
                  </p>
                </article>
              </div>
            </section>

            <section className="epw-closing">
              <strong>Global reach. Regional understanding. Analytical discipline.</strong>
              <p>
                Together, EnergyPulse Inc. and EnergyPulseWorld aim to provide reliable,
                independent intelligence that connects energy developments with their wider
                implications for economies, industry and trade.
              </p>
            </section>

          </div>
        </section>
      </main>
    </div>
  )
}

export default WhoWeArePage
